import { useQuery } from "@tanstack/react-query";
import {
  getProviderOrInstitutionBySlug,
  triggerContactDiscovery,
} from "../../api/provider.public.api";
import { AddressRow, InstitutionRecord, MedicalSpecialty, ProviderRecord } from "../../api/provider.type";

export type PublicProviderData = {
  type: "provider" | "institution";
  record: ProviderRecord | InstitutionRecord;
  address: AddressRow | null;
  medical_specialty: MedicalSpecialty | null;
};

export function usePublicProvider(slug?: string) {
  return useQuery<PublicProviderData>({
    queryKey: ["public-provider", slug],
    enabled: Boolean(slug),
    queryFn: async () => {
      if (!slug) throw new Error("Missing slug");
      const data = await getProviderOrInstitutionBySlug(slug);
      // Best-effort trigger to populate contacts if empty
      try {
        void triggerContactDiscovery(slug);
      } catch {}
      return data;
    },
    staleTime: 60_000,
  });
}

export default usePublicProvider;

